export class GdsgQueueLagStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "worstSlaEnqueueTs",
            "baseName": "worstSlaEnqueueTs",
            "type": "string",
            "format": ""
        },
        {
            "name": "worstSlaMs",
            "baseName": "worstSlaMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "activeShards",
            "baseName": "activeShards",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "observedShards",
            "baseName": "observedShards",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgQueueLagStats.attributeTypeMap;
    }
    constructor() {
    }
}
